import {
  EditOutlined,
  StopOutlined,
  ArrowUpOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Popconfirm,
  message,
  Tooltip,
  Tag,
  Row,
  Col,
  Spin,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TableItem,
  ButtonItem,
  BoxItem,
  HeaderItem,
  dineroDisabledMask,
  MensajeError,
} from "../../../../Components/Items";
import EditarCredito from "../EditarCredito/EditarCredito";
import AumentarCredito from "../AumentarCredito/AumentarCredito";

const coloresTipo = {
  alta: "blue",
  pagoInicial: "purple",
  aumento: "green",
  pago: "orange",
};

class VerCredito extends Component {
  state = {
    id: null,
    credito: null,
    movimientos: [],
    loading: false,
    modalEditarCredito: false,
    modalAumentarCredito: false,
  };

  componentDidMount() {
    const id = this.props.location.state?.id;

    //Sin id no hay nada que mostrar (pasa al recargar la pagina, porque el id
    //viaja en el state del router y no en la url)

    if (!id) {
      this.props.history.replace("/panel/creditos");
      return;
    }

    this.setState({ id: id }, () => this.consultarMovimientos());
  }

  consultarMovimientos() {
    this.setState({ loading: true });
    axios
      .post(
        "creditos/movimientosCredito",
        { creditoId: this.state.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            credito: res.data.credito,
            movimientos: res.data.movimientos || [],
          });
        } else {
          message.error(
            res.data.message || "Sucedió un error y no se pudo consultar"
          );
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  abrirEditarCredito() {
    this.setState({ modalEditarCredito: true });
  }
  cerrarEditarCredito() {
    this.setState({ modalEditarCredito: false });
    this.consultarMovimientos();
  }
  abrirAumentarCredito() {
    this.setState({ modalAumentarCredito: true });
  }
  cerrarAumentarCredito() {
    this.setState({ modalAumentarCredito: false });
    this.consultarMovimientos();
  }

  verPoliza(polizaId) {
    this.props.history.push("/panel/verPoliza", { id: polizaId });
  }

  //Despacha la cancelacion segun el tipo de movimiento de la fila

  cancelarMovimiento(accion) {
    if (accion.tipo === "alta") {
      this.enviarCancelacion("creditos/cancelarCredito", {
        creditoId: this.state.id,
        empresaId: this.props.empresaId,
      });
      return;
    }

    if (accion.tipo === "aumento") {
      this.enviarCancelacion("creditos/cancelarAumentoCredito", {
        creditoId: this.state.id,
        movimientoId: accion.referenciaId,
        polizaId: accion.polizaId,
        empresaId: this.props.empresaId,
      });
      return;
    }

    if (accion.tipo === "pago") {
      this.enviarCancelacion("pagos/cancelarPago", {
        pagoId: accion.referenciaId,
        empresaId: this.props.empresaId,
      });
    }
  }

  enviarCancelacion(url, body) {
    this.setState({ loading: true });
    axios
      .post(url, body, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Movimiento cancelado");
        } else {
          // Cuando el movimiento es un pago, `pagos/cancelarPago` devuelve el acuse del
          // SAT ya interpretado en `errorTimbrado`. Para los demás tipos no viene y se
          // cae al `message` de siempre, así que sirve para los dos casos.
          MensajeError({
            message: res.data.errorTimbrado?.titulo || "No se pudo cancelar el movimiento",
            description: res.data.errorTimbrado?.mensaje || res.data.message,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        }
        this.consultarMovimientos();
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Sucedió un error y no se pudo cancelar");
      });
  }

  tituloPopconfirm(accion) {
    if (accion.tipo === "alta") {
      return "Esto cancela el crédito completo y todas sus pólizas. No se podrá reactivar. ¿Continuar?";
    }
    if (accion.tipo === "aumento") {
      return "Seguro que quieres cancelar este aumento (se descontará del total y del saldo del crédito)";
    }
    if (accion.mixto) {
      return accion.detalleMixto + " ¿Continuar?";
    }
    return "Seguro que quieres cancelar este pago (se regresará el saldo al crédito y al banco)";
  }

  render() {
    const credito = this.state.credito;

    const columns = [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: "10%",
        render: (value) => (value ? moment(value).locale("es").format("L") : ""),
      },
      {
        title: "Tipo",
        dataIndex: "tipoLabel",
        key: "tipoLabel",
        width: "12%",
        render: (value, record) => (
          <Tag color={coloresTipo[record.tipo] || "default"}>{value}</Tag>
        ),
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
      },
      {
        title: "Monto",
        dataIndex: "monto",
        key: "monto",
        align: "right",
        width: "13%",
        render: (value) => dineroDisabledMask(value),
      },
      {
        title: "Póliza",
        //dataIndex "accion" para que TableItem no le ponga ellipsis y no
        //recorte los botones; los datos se leen del record
        dataIndex: "accion",
        key: "polizas",
        width: "18%",
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { padding: "4px" },
        }),
        render: (value, record) => {
          const polizas = record.polizas;
          const abono = record.abonoProveedor;

          if ((!polizas || polizas.length === 0) && !abono) {
            return <span style={{ color: "#999" }}>Sin póliza</span>;
          }
          return (
            <div className="acciones-container">
              {(polizas || []).map((poliza) => (
                <ButtonItem
                  key={`poliza-${poliza._id}`}
                  type="default"
                  size="small"
                  azul
                  icon={<EyeOutlined />}
                  onClick={() => this.verPoliza(poliza._id)}
                >
                  {poliza.etiqueta}
                </ButtonItem>
              ))}
              {abono && (
                <Tooltip
                  title={
                    "Abono al proveedor por " +
                    dineroDisabledMask(abono.monto) +
                    ". Aplicado: " +
                    dineroDisabledMask(abono.aplicado) +
                    ". Disponible: " +
                    dineroDisabledMask(abono.disponible)
                  }
                >
                  <Tag color={abono.estado === 1 ? "blue" : "red"}>
                    {abono.folio}
                  </Tag>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        align: "center",
        width: "10%",
        render: (value) =>
          value === 0 ? (
            <Tag color="red">Cancelado</Tag>
          ) : (
            <Tag color="green">Vigente</Tag>
          ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "9%",
        onHeaderCell: () => ({
          style: { textAlign: "center", padding: "4px" },
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: "center", padding: "4px" },
        }),
        render: (value, record, index) => {
          if (!this.props.permisoCancelarCredito) return null;

          if (!value.cancelable) {
            return (
              <Tooltip
                key={`cancelar-disabled-${index}`}
                title={value.motivoNoCancelable || "No disponible"}
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  rojo2
                  icon={<StopOutlined />}
                  disabled={true}
                ></ButtonItem>
              </Tooltip>
            );
          }

          return (
            <Popconfirm
              key={`cancelar-${index}`}
              title={this.tituloPopconfirm(value)}
              onConfirm={() => this.cancelarMovimiento(value)}
              okText="Si"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Tooltip
                title="Cancelar"
                placement="top"
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "1px 5px",
                  minHeight: "auto",
                }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<StopOutlined />}
                ></ButtonItem>
              </Tooltip>
            </Popconfirm>
          );
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Ver Crédito"
          subTitle={credito ? credito.nombre : ""}
          onBack={() => this.props.history.goBack()}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            credito && credito.estado === 1
              ? [
                  this.props.permisoEditarCreditos && (
                    <ButtonItem
                      key="aumentarCredito"
                      type="default"
                      verde
                      icon={<ArrowUpOutlined />}
                      onClick={this.abrirAumentarCredito.bind(this)}
                    >
                      Aumentar
                    </ButtonItem>
                  ),
                  this.props.permisoEditarCreditos && (
                    <ButtonItem
                      key="editarCredito"
                      type="default"
                      cyan
                      icon={<EditOutlined />}
                      onClick={this.abrirEditarCredito.bind(this)}
                    >
                      Editar
                    </ButtonItem>
                  ),
                ]
              : null
          }
        />
        <Spin spinning={this.state.loading}>
          {credito && (
            <BoxItem>
              <Row>
                <Col span={24} style={{ textAlign: "center" }}>
                  <HeaderItem>
                    {credito.nombre}{" "}
                    {credito.estado === 1 ? (
                      <Tag color="green">Activo</Tag>
                    ) : (
                      <Tag color="red">Cancelado</Tag>
                    )}
                    {credito.contablemente === false && (
                      <Tooltip title="Se dio de alta sin generar pólizas: la contabilidad ya estaba registrada">
                        <Tag color="default">Sin contabilidad</Tag>
                      </Tooltip>
                    )}
                    {credito.abonoProveedor && (
                      <Tooltip title="El cargo va a la cuenta de anticipos del proveedor y genera un abono aplicable a sus facturas desde Cuentas Por Pagar">
                        <Tag color="blue">Abono a proveedor</Tag>
                      </Tooltip>
                    )}
                  </HeaderItem>
                </Col>
              </Row>
              <Row gutter={[8, 4]} style={{ marginTop: 8 }}>
                <Col xs={24} md={8}>
                  <b>Proveedor: </b>
                  {credito.proveedor?.nombre || ""}
                </Col>
                <Col xs={24} md={8}>
                  <b>Proyecto: </b>
                  {credito.proyecto?.nombre || ""}
                </Col>
                <Col xs={24} md={8}>
                  <b>Moneda: </b>
                  {credito.moneda
                    ? credito.moneda.abreviacion + " - " + credito.moneda.nombre
                    : ""}
                </Col>
                <Col xs={24} md={8}>
                  <b>Total Crédito: </b>
                  {dineroDisabledMask(credito.totalCredito)}
                </Col>
                <Col xs={24} md={8}>
                  <b>Total Pagado: </b>
                  {dineroDisabledMask(credito.totalPagado)}
                </Col>
                <Col xs={24} md={8}>
                  <b>Saldo: </b>
                  {dineroDisabledMask(credito.saldo)}
                </Col>
                <Col xs={24} md={8}>
                  <b>Fecha Inicio: </b>
                  {credito.fechaInicio
                    ? moment(credito.fechaInicio).locale("es").format("L")
                    : ""}
                </Col>
                <Col xs={24} md={8}>
                  <b>Fecha Vencimiento: </b>
                  {credito.fechaVencimiento
                    ? moment(credito.fechaVencimiento).locale("es").format("L")
                    : ""}
                </Col>
                <Col xs={24} md={8}>
                  <b>Plazo: </b>
                  {credito.plazo ? credito.plazo + " meses" : ""}
                </Col>
              </Row>
            </BoxItem>
          )}
          <div style={{ marginTop: 10 }}>
            <TableItem
              size="small"
              dataSource={this.state.movimientos}
              columns={columns}
              rowKey="key"
            />
          </div>
        </Spin>
        {this.props.permisoEditarCreditos && (
          <EditarCredito
            id={this.state.id}
            visible={this.state.modalEditarCredito}
            cerrarEditarCredito={this.cerrarEditarCredito.bind(this)}
          />
        )}
        {this.props.permisoEditarCreditos && (
          <AumentarCredito
            credito={
              credito
                ? {
                    _id: credito._id,
                    nombre: credito.nombre,
                    totalCredito: credito.totalCredito,
                    saldo: credito.saldo,
                    abonoProveedor: credito.abonoProveedor,
                  }
                : null
            }
            visible={this.state.modalAumentarCredito}
            cerrarAumentarCredito={this.cerrarAumentarCredito.bind(this)}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoEditarCreditos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207327cd914b37f4b03308"
      )?.activado,
    permisoCancelarCredito:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a207331cd914b37f4b03309"
      )?.activado,
  };
};

export default connect(mapStateToProps)(VerCredito);
